import React, { useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core';
import { formatMoney } from 'helpers/moneyFormatter';

const useStyles = makeStyles({
  container: {
    margin: '0.25em 0',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.25em 0',
  },
  option: {
    margin: '0.2em 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  optionText: {
    fontSize: '0.85rem',
  },
  text: {
    fontSize: '0.85rem',
  },
  categoryName: {
    fontSize: '0.85rem',
    textTransform: 'capitalize',
    marginTop: '0.5em',
    fontWeight: 500,
  },
});

function showProductOption({ amount, product_option }) {
  return `${amount}x - ${product_option.name}`;
}

function RequestProductItem({ productRequest, classes }) {
  const additionCategories = useMemo(() => {
    const { additions } = productRequest;

    if (!additions.length) {
      return [];
    }

    const categories = new Map();
    additions.forEach((addition) => {
      if (!addition) {
        return;
      }

      const { category_product_option } = addition.product_option;
      if (
        category_product_option &&
        !categories.has(category_product_option.name)
      ) {
        categories.set(category_product_option.name, []);
      }

      if (category_product_option) {
        categories.get(category_product_option.name).push(addition);
      }
    });
    return Array.from(categories.entries()).map(
      ([categoryName, additions]) => ({
        name: categoryName,
        additions,
      }),
    );
  }, [productRequest]);

  return (
    <Box key={productRequest.id} className={classes.container}>
      <Box className={classes.item}>
        <Typography className={classes.text}>
          {`${productRequest.amount}x - ${productRequest.product.name}`}
        </Typography>
        <Typography className={classes.text}>
          {formatMoney(productRequest.current_price)}
        </Typography>
      </Box>

      {!!productRequest.note && (
        <Typography className={classes.text}>
          <em>
            <b>Anotações:</b> {productRequest.note}
          </em>
        </Typography>
      )}

      {additionCategories.map((additionCategory, index) => (
        <div key={String(index + 1)}>
          <Typography className={classes.categoryName}>
            <p>{additionCategory.name}</p>
          </Typography>

          {additionCategory.additions.map((addition) => (
            <div key={String(addition.id)} className={classes.option}>
              <Typography className={classes.optionText}>
                {showProductOption(addition)}
              </Typography>

              <Typography className={classes.optionText}>
                {formatMoney(addition.product_option.price)}
              </Typography>
            </div>
          ))}
        </div>
      ))}

      <Divider />
    </Box>
  );
}

export default function PrintRequestProductList({ requestProducts }) {
  const classes = useStyles();

  return requestProducts.map((productRequest) => (
    <RequestProductItem
      key={productRequest.id}
      classes={classes}
      productRequest={productRequest}
    />
  ));
}
